module.exports = __webpack_public_path__ + "img/app_terms_intro_bg.cc2064ac.png";